export const SET_NAVIGATION = '[NAVIGATION] SET NAVIGATION';
export const REMOVE_NAVIGATION = '[NAVIGATION] REMOVE NAVIGATION';

export function setNavigation(value)
{
    return {
        type: SET_NAVIGATION,
        payload: value
    };
}

export function removeNavigation()
{
    return {
        type: REMOVE_NAVIGATION
    }
}

